import { useShallow } from "zustand/shallow";
import {
  OrderByType,
  orderByTypes,
  useDiscoveryV2SearchStore,
} from "../DiscoveryV2SearchStore";
import { useFeatureFlagStore } from "~/hooks/useFeatureFlags";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";
import {
  InputContainer,
  InputOption,
  InputSelect,
} from "@sellar-io/components";
import { twMerge } from "tailwind-merge";

export const OrderBySelector = ({
  className,
  label,
  selectClassName,
  labelClassName,
}: {
  className?: string;
  label?: string;
  selectClassName?: string;
  labelClassName?: string;
} = {}) => {
  const { orderBy, setOrderBy } = useDiscoveryV2SearchStore(
    useShallow((state) => ({
      orderBy: state.orderBy,
      setOrderBy: state.setOrderBy,
    })),
  );
  const showBestsellers = useFeatureFlagStore().isActive(
    "DISCOVERY_BESTSELLERS_ENABLED",
  );
  const recommendedSortEnabled = useRemoteFeatureFlags().isActive(
    "recommendedDiscoverySearch",
  );
  return (
    <InputContainer className={className}>
      {label && (
        <span className={twMerge("shrink-0", labelClassName)}>{label}</span>
      )}
      <InputSelect
        className={twMerge(label && "w-auto", selectClassName)}
        onClick={(event) => {
          event.stopPropagation();
        }}
        value={orderBy}
        onChange={(event) => {
          event.stopPropagation();
          setOrderBy(event.target.value as OrderByType);
        }}
      >
        {Object.keys(orderByTypes)
          .filter(
            (orderByKey) => orderByKey !== "bestsellers" || showBestsellers,
          )
          .map((orderByKey) => (
            <InputOption key={orderByKey} value={orderByKey}>
              {orderByKey === "popular" && recommendedSortEnabled
                ? "Recommended"
                : orderByTypes[orderByKey as OrderByType]}
            </InputOption>
          ))}
      </InputSelect>
    </InputContainer>
  );
};
